// extracted by mini-css-extract-plugin
export default {"PostCreate":"qf_a bhi_qr bhi_a bhi_w bhi_ea"};